import(/* webpackMode: "eager" */ "/home/runner/work/sk-aqua/sk-aqua/assets/logo-light.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/sk-aqua/sk-aqua/components/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/sk-aqua/sk-aqua/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/sk-aqua/sk-aqua/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/sk-aqua/sk-aqua/sections/Contact.jsx");
